import React from "react";
import Plot from "react-plotly.js";

export const ManagerialChart = ({ data, layout, config, style }) => {
  return (
    <Plot
      data={data}
      layout={layout}
      config={{
        displaylogo: false,
        responsive: true,
        useResizeHandler: true,
        ...config,
      }}
      style={{ width: "100%", height: "400px", ...style }} 
    />
  );
};
